var _defs, _circle, _animateTransform;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSpinnerNeutral = function SvgSpinnerNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    color: "#fff",
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner-neutral_svg__a",
    y2: 1,
    x2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "currentColor",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner-neutral_svg__b",
    y2: 1,
    x2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "currentColor",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "spinner-neutral_svg__c",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#spinner-neutral_svg__a)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "-50%",
    width: "100%",
    height: "100%",
    fill: "url(#spinner-neutral_svg__b)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    strokeWidth: 4,
    stroke: "url(#spinner-neutral_svg__c)"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    from: "360 0 0",
    to: "0 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "2000ms"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0OCA0OCIgY29sb3I9IiNmZmZmZmYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImdyYWQtMSIgeTI9IjEiIHgyPSIwIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSJjdXJyZW50Q29sb3IiIHN0b3Atb3BhY2l0eT0iMC4zIiAvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9ImN1cnJlbnRDb2xvciIgc3RvcC1vcGFjaXR5PSIwIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iZ3JhZC0yIiB5Mj0iMSIgeDI9IjAiPgogICAgICA8c3RvcCBvZmZzZXQ9IjEwJSIgc3RvcC1jb2xvcj0iY3VycmVudENvbG9yIiBzdG9wLW9wYWNpdHk9IjAiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iY3VycmVudENvbG9yIiBzdG9wLW9wYWNpdHk9IjEiIC8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPHBhdHRlcm4gaWQ9InBhdHRlcm4iIHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyYWQtMSkiIC8+CiAgICAgIDxyZWN0IHg9Ii01MCUiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZC0yKSIgLz4KICAgIDwvcGF0dGVybj4KICA8L2RlZnM+CiAgCiAgPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjAiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlPSJ1cmwoI3BhdHRlcm4pIiAvPgogIDxhbmltYXRlVHJhbnNmb3JtCiAgICBmcm9tPSIzNjAgMCAwIgogICAgdG89IjAgMCAwIgogICAgYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIgogICAgdHlwZT0icm90YXRlIgogICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiCiAgICBkdXI9IjIwMDBtcyIKICAvPgo8L3N2Zz4K";
export { SvgSpinnerNeutral as ReactComponent };